export const LabelTitle = ({ children, height, align, size, styles }) => {
  return (
    <span
      style={{
        display: "flex",
        textAlign: align || "center",
        justifyContent: align || "center",
        alignItems: "center",
        height: height || "20px",
        fontSize: size,
        ...styles,
      }}
    >
      {children}
    </span>
  );
};
